import { UTSLocale } from "@smile2impress/attraction-constants";
import { withCdnUrl } from "@smile2impress/attraction-utils";

export enum UrlsConfig {
    HOME_PAGE_URL = "https://smile2impress.com",
    PRESS_RELEASES = "https://press.smile2impress.com",
    VENEERS_LANDING = "https://getstarted.smile2impress.com/pages/veneers",
    TILDA_BUNDLE_STORE = "https://store.smile2impress.com",
    HS_SITE = "https://smile2impress-5970216.hs-sites.com",
    DEV_STATIC_S3_URL = "https://static-dev.smile2impress.com",
    PRELIVE_STATIC_S3_URL = "https://static-prelive.smile2impress.com",
    LIVE_STATIC_S3_URL = "https://static.smile2impress.com",
    DR_SMILE_BOOKING = "https://drsmile.fr/booking-v2-lead/",
    DR_SMILE_FAQ = "https://drsmile.fr/faq/impress/",
    WHATSAPP_BASE_URL = "https://wa.me",

    MAIN = "/",
    UNIVERSAL_FORM = "/universal-form",
    ULTRA_FORM = "/ultra-form",
    SMILE_VISION_TYPEFORM = "/smile-vision",
    SMILE_VISION_RESULTS = "/smile-vision-results",
    SMILE_VISION_OFFER = "/smile-vision-offer",
    SMILE_VISION_OFFER_BY_ID = "/smile-vision-offer/[offerId]",
    ABOUT = "/about",
    ADVANCED = "/advanced",
    TEENS = "/teen",
    FACEBOOK_FORM = "/facebook-form",
    KIDS = "/kids",
    WHY_IMPRESS = "/why-impress",
    HOW_IT_WORKS = "/how-it-works",
    PRICES = "/prices",
    RESULTS = "/results",
    LOCATIONS = "/locations",
    CITY = "/locations/[cityName]",
    BLOG = "/blog",
    BLOG_POST = "/blog/[id]",
    BOOKING_WIDGET = "/booking-widget",
    C2 = "/c2",
    UNIVERSAL_SELECT = "/universal-select",
    FIRST_VISIT = "/first-visit",
    REFERRAL = "/referral",
    REFERRAL_NON_PATIENTS = "/referral-non-patients",
    REFERRAL_FOR_FRIENDS = "/referral-for-friends",
    REFERRAL_FOR_FRIENDS_NON_PATIENTS = "/referral-friends-non-patients",
    THANKS_SIGN = "/thanks-sign",
    THANKS_MAIL = "/thanks-mail",
    THANKS_CONTACT = "/thanks-contact",
    ERROR = "/_error",
    POLICY = "/policy",
    QUIZ = "/quiz",
    QUIZ_RESULTS = "/quiz-results",
    QUIZ_PARTIAL_RESULTS = "/quiz-partial-results",
    CANDIDATE_PARTIAL_LEAD = "/candidate-partial-lead",
    QUIZ_COMPLETED = "/quiz-completed",
    CLINIC = "/clinic",
    CLINIC_RELAUNCH = "/clinic/[id]",
    RETAINERS_SUBSCRIPTION = "/retainers-subscription",
    VERIFICATION_FAILED = "/verification-failed",
    ALIGNERS = "/aligners",
    WHITENING = "/whitening",
    CANDIDATE = "/candidate",
    CANDIDATE_INVISALIGN = "/candidate-invisalign",
    DRSMILE_LEADFORM = "/dr-smile-universal-form",
    DRSMILE_BOOKING = "/dr-smile-booking-widget",
    DRSMILE_THANKS_CONTACT = "/dr-smile-thanks-contact",
    BOOKING_SUCCESS = "/booking-success",
    BOOKING_CALL_REQUESTED = "/booking-call-requested",
    MALOCCLUSION = "/malocclusion",
    CROSSBITE = "/malocclusion/crossbite",
    MAIN_TREATMENT = "/treatment",
    CROOKED_TEETH = "/malocclusion/crooked-teeth",
    BEFORE_THE_TREATMENT = "/treatment/before-the-treatment",
    AFTER_THE_TREATMENT = "/treatment/after-the-treatment",
    COMPLAINTS = "/complaints",
    DURING_THE_TREATMENT = "/treatment/during-the-treatment",
    DIASTEMA = "/malocclusion/diastema",
    OVERBITE = "/malocclusion/overbite",
    UNDERBITE = "/malocclusion/underbite",
    CROWDING = "/malocclusion/crowding",
    BUCKTEETH = "/malocclusion/buckteeth",
    TEETHMOVING = "/malocclusion/teethmoving",
    QUALITY_TECHNOLOGY = "/quality-technology",
    VENEERS = "/veneers",
    COMPLAINS_FORMULAR = "/complains-formular",
    CMS_PREVIEW = "/cms-preview/[[...slug]]",
    CMS_BLOG_PREVIEW = "/cms-preview/blog/[id]",
    CMS_PAGES = "/[[...slug]]",
    SMAJLA_LEADFORM = "/smajla-universal-form",
    SMAJLA_BOOKING = "/smajla-booking-widget",
    SMAJLA_THANKS_CONTACT = "/smajla-thanks-contact",
    SMAJLA_TYPEFORM = "/smajla/behover-jag-osynliga-tandstallningar-test",
    TYPEFORM_CPH = "/question-form-cph",
    STUDENT_BEANS = "/student-beans",
    DISCOUNT = "/discount",
    BOOKING_WIDGET_SCROLLER = "/booking-widget-scroller",
}

export const MEDICARE_URL_QUERY = "medicare";

export const UrlsCookiesPolicyConfig = {
    [UTSLocale.FRANCE_FR]: withCdnUrl("/policy/cookies-policy_france.pdf"),
    [UTSLocale.ITALY_IT]: withCdnUrl("/policy/cookies-policy_italy.pdf"),
    [UTSLocale.PORTUGAL_PT]: withCdnUrl("/policy/cookies-policy_portugal.pdf"),
    [UTSLocale.SPAIN_ES]: withCdnUrl("/policy/cookies-policy_spain.pdf"),
    [UTSLocale.GB_EN]: withCdnUrl("/policy/cookies-policy_uk.pdf"),
    [UTSLocale.UKRAINE_UK]: withCdnUrl("/policy/cookies-policy_ukraine.pdf"),
    [UTSLocale.US_EN]: withCdnUrl("/policy/cookies-policy_us.pdf"),
    [UTSLocale.NL_NL]: withCdnUrl("/policy/cookies-policy_uk.pdf"),
    [UTSLocale.DENMARK_DK]: withCdnUrl("/policy/cookies-policy_uk.pdf"), // TODO AD-2185: DK-specific cookies policy URL
};

export const UrlsQuizConfig = {
    [UTSLocale.FRANCE_FR]:
        "/comment-savoir-si-on-a-besoin-d-un-appareil-dentaire",
    [UTSLocale.ITALY_IT]: "/devo-mettere-apparecchio-quiz-ortodonzia",
    [UTSLocale.PORTUGAL_PT]:
        "/como-saber-se-preciso-de-aparelho-dentario-teste",
    [UTSLocale.SPAIN_ES]: "/como-saber-si-necesitas-brackets-alineadores-test",
    [UTSLocale.GB_EN]: "/do-i-need-braces-aligners-quiz",
    [UTSLocale.US_EN]: "/do-i-need-braces-aligners-quiz",
    [UTSLocale.UKRAINE_UK]: "",
    [UTSLocale.NL_NL]: "",
    [UTSLocale.GERMANY_DE]: "",
    [UTSLocale.SWEDEN_SE]: "",
    [UTSLocale.DENMARK_DK]: "",
};

export const promotionUrlConfig = {
    [UTSLocale.GB_EN]:
        "https://5970216.hs-sites.com/uk/baseslegales_flashsale_24",
    [UTSLocale.US_EN]: undefined,
    [UTSLocale.SPAIN_ES]: undefined,
    [UTSLocale.FRANCE_FR]: undefined,
    [UTSLocale.ITALY_IT]: undefined,
    [UTSLocale.PORTUGAL_PT]:
        "https://5970216.hs-sites.com/pt/baseslegales_flashsale_24",
    [UTSLocale.UKRAINE_UK]: undefined,
    [UTSLocale.NL_NL]: undefined,
    [UTSLocale.GERMANY_DE]: undefined,
    [UTSLocale.SWEDEN_SE]: undefined,
    [UTSLocale.DENMARK_DK]: undefined,
};

export const PRIVACY_POLICY_LINKS_BY_LOCALE = {
    [UTSLocale.ITALY_IT]: `${UrlsConfig.HS_SITE}/it/informativa-sulla-privacy/`,
    [UTSLocale.SPAIN_ES]: `${UrlsConfig.HS_SITE}/es/tratamiento-de-datos-personales/`,
    [UTSLocale.PORTUGAL_PT]: `${UrlsConfig.HS_SITE}/pt/processamento-de-dados-pessoais/`,
    [UTSLocale.FRANCE_FR]: `${UrlsConfig.HS_SITE}/fr/protectiondesdonnees/`,
    [UTSLocale.UKRAINE_UK]: `${UrlsConfig.HS_SITE}/ua/polityka-konfidentsiinosti/`,
    [UTSLocale.GB_EN]: `${UrlsConfig.HS_SITE}/en-gb/uk/privacy-policy/`,
    [UTSLocale.US_EN]: `${UrlsConfig.HS_SITE}/us/privacy-policy/`,
    [UTSLocale.SWEDEN_SE]: `${UrlsConfig.HS_SITE}/legal/privacy-policy/impress/`,
    [UTSLocale.NL_NL]: `${UrlsConfig.HS_SITE}/nl-nl/juridisch/impressum/`,
    [UTSLocale.GERMANY_DE]: `${UrlsConfig.HS_SITE}/de-de/legal/impressum/`,
    [UTSLocale.DENMARK_DK]: `${UrlsConfig.HS_SITE}/legal/privacy-policy/impress/`, // TODO AD-2185: DK-specific URL, reusing SE
};

/** Locale-neutral paths — Link localizes via localized-pathnames.json. */
export const OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE = {
    [UTSLocale.SPAIN_ES]: UrlsConfig.DISCOUNT,
    [UTSLocale.UKRAINE_UK]: UrlsConfig.DISCOUNT,
    [UTSLocale.PORTUGAL_PT]: UrlsConfig.DISCOUNT,
    [UTSLocale.GB_EN]: UrlsConfig.DISCOUNT,
    [UTSLocale.NL_NL]: UrlsConfig.DISCOUNT,
    [UTSLocale.GERMANY_DE]: UrlsConfig.DISCOUNT,
    [UTSLocale.FRANCE_FR]: UrlsConfig.DISCOUNT,
    [UTSLocale.US_EN]: "",
    [UTSLocale.SWEDEN_SE]: UrlsConfig.DISCOUNT,
    [UTSLocale.ITALY_IT]: "",
    [UTSLocale.DENMARK_DK]: "", // TODO AD-2185: DK-specific URL
};
